import React from 'react';
import "./ReportTable.css";
import { numberWithCommas, roundTo2Decimals, dollarFormatWithCommas } from "../../util";
import { UncontrolledTooltip } from "reactstrap";



function NewlineText(text) {
  
  return text.split('~').map(str => <p>{str}</p>);
}


const reportTable = (props) => {
	const headers = [];
	const tooltips = [];

	let accumulatorIndex = 0;
	let accumulatorSettings = 0;
	let anyHeader = false;

	let allowBold = !props.boldingOff || !props.boldingOff;
	const rowSettings = props.settings.map((col, index) => {
		if(col.header.length > 0)
			anyHeader = true;
	
		headers.push(<th key={col.header} className={["ReportTableHeader", col.accessor].join(" ")} id={props.name + col.accessor}>{NewlineText(col.header)}</th>);

		if (col.tooltip) {
			tooltips.push(<UncontrolledTooltip innerClassName={"table-tooltip-text"} placement="right"
				key={col.accessor} target={props.name + col.accessor}>
				{col.tooltip}
			</UncontrolledTooltip>);
		}

		let settings = {
			accessor: col.accessor,
			dollarValue: !!col.dollarValue,
			formatNumberWithCommas: !!col.formatNumberWithCommas,
			percentageNumber: !!col.percentageNumber,
			percentageSign: !!col.percentageSign,
			round2Decimals: !!col.round2Decimals,
			round1Decimal: !!col.round1Decimal,
			truncateDecimal: !!col.truncateDecimal,
			inThousands: !!col.inThousands,
			inverseValue: !!col.inverseValue,
			blockZeros: !!col.blockZeros,
			blockNull: !!col.blockNull,
			statType: !!col.statType,
			map: col.map,
			centerRightJustified: !!col.centerRightJustified,
			centerWideJustified: !!col.centerWideJustified,
			style: !!col.style ? col.style : {},
			isBold: !!col.isBold,
			dollarValueWithCommas: !!col.dollarValueWithCommas,
			textOnly: !!col.textOnly,
			cellText: col.cellText,
		};
		if (col.round2whole) {
			settings.round2whole = col.round2whole;
		}

		if (props.accumulator && props.accumulator === col.accessor) {
			accumulatorIndex = index;
			accumulatorSettings = settings;
		}

		return settings;
	});

	let rows = null;
	let accumulatedValue = 0;
	let accumulatorInnerClassNames = [];
	let accumulatorDollarSignOverride = false;

	function applySettings(setting, accessedData, index, innerClassNames, dollarSignOverride) {
		if(!accessedData && props.isNotApplicable === "Yes") {
			return 'N/A';
		}
		if(setting.map && setting.map[accessedData]) {
			accessedData = setting.map[accessedData];
		}
		if(setting.blockNull && accessedData === null) {
			return accessedData
		}

		if(accessedData === null) {
			return "-";
		}
		if(setting.blockZeros) {
			if(!accessedData) {
				if(accessedData === 0) {
					return "-";
				}
			}
		}
		
		if(setting.inverseValue) {
			accessedData = accessedData * -1;
		}

		if(setting.inThousands && !isNaN(accessedData) ) {
			accessedData = accessedData / 1000;
		}

		
		if(setting.percentageNumber && !isNaN(accessedData)) {
			accessedData = roundTo2Decimals(accessedData * 100);
		}

		if(setting.truncateDecimal && !isNaN(accessedData)) {
			accessedData = Math.round(accessedData);
		}

		if(setting.round2Decimals && !isNaN(accessedData)) {
			accessedData = accessedData.toFixed(2);
		}

		if(setting.round1Decimal && !isNaN(accessedData) && accessedData !== "TBD") {
			if(accessedData.toString().length > 4)
				accessedData = accessedData.toFixed(2);
			else
				accessedData = accessedData.toFixed(1);
		}
		if(setting.round2whole && setting.round2whole !== undefined && !isNaN(accessedData)) {
			accessedData = accessedData.toString();
			let tempData = accessedData.split('.');
			accessedData = Math.round(tempData[0]);
		}

		//string formatters
		if(setting.formatNumberWithCommas && !isNaN(accessedData)) {
			accessedData = numberWithCommas(accessedData);
		}

		if(setting.dollarValue) {
   //          if(setting.dollarValue && (index === 0 || dollarSignOverride)) {
			accessedData = '$' + accessedData;
		}
		if(setting.dollarValueWithCommas) {	
			
			accessedData = "$" + numberWithCommas(parseFloat(accessedData).toFixed(2));
		};

		if(setting.percentageSign && !isNaN(accessedData)) {
			accessedData = accessedData + '%'
		}

		if(setting.statType && !isNaN(accessedData)) {
			switch(accessedData) {
				case 1: accessedData = "Type I";
				break;				

				case 2: accessedData = "Type II";
				break;				
				
				case 3: accessedData = "High-Risk";
				break;

				default: accessedData = "";
				break;
			}
		}

		if(setting.centerRightJustified) {
			innerClassNames.push(props.name + "CenterRightJustified");
			innerClassNames.push("CenterRightJustified");
		}
		if(setting.centerWideJustified) {
			innerClassNames.push(props.name + "centerWideJustified");
			innerClassNames.push("centerWideJustified");
		}
		return accessedData;
	}


	let isAce = false;
	let overrideCenter = false;
	if (props.data) {
		//if(approxMarketCapLoss)
		let dollarSignOverrides = {};
		rows = props.data.map((data, index) => {
			/*
			console.log("data");
			console.log(data);
			console.log("data.hasOwnProperty('approxMarketCapLoss')");
			console.log(data.hasOwnProperty('approxMarketCapLoss'));
			console.log("data['approxMarketCapLoss']");
			console.log(data['approxMarketCapLoss']);
			*/
			overrideCenter = false;
			
			if(allowBold) {

				if(data.hasOwnProperty('approxMarketCapLoss') && data['approxMarketCapLoss'] !== null && data['approxMarketCapLoss'] < 0) {
					isAce = true;
				} else if((data.hasOwnProperty('maxDollarOfArtificialInflationPerShare') && data['maxDollarOfArtificialInflationPerShare'] && data.hasOwnProperty('statSignificance') && data['statSignificance'] ) || (data.hasOwnProperty('statSignificance') && data['statSignificance'] === "No" )){
					isAce = true;
				} else if(data.hasOwnProperty('name') && data['name'] && data.hasOwnProperty('value') && data['value'] === null) {
					isAce = true;
					overrideCenter = true;
				} else {

					isAce = false;
				}
				if((data.hasOwnProperty('severe') && data['severe'] === 'No') || (data.hasOwnProperty('severe') && data['severe'] === 'No')) {
					isAce = false;
				}
			}

			return <tr key={index}>
				{rowSettings.map((setting, i) => {
					const accessor = setting.accessor;
					let accessedData = data[accessor];
					let innerClassNames = [];
					if(setting.textOnly) {
						accessedData = setting.cellText;
					} else if (!accessedData) {
						if(!accessedData && props.isNotApplicable === "Yes") {
							accessedData =  'N/A';
						} else {
							accessedData = applySettings(setting, accessedData, index, innerClassNames, dollarSignOverrides[i]);
						}
						dollarSignOverrides[i] = true;
					} else {

						if (props.accumulator && props.accumulator === accessor) {
							accumulatedValue += accessedData;
							accumulatorDollarSignOverride = dollarSignOverrides[i];
						}

						accessedData = applySettings(setting, accessedData, index, innerClassNames, dollarSignOverrides[i]);

						if (props.accumulator && props.accumulator === accessor) {
							accumulatorInnerClassNames = innerClassNames.slice()
						}
					}
					//console.log("accessedData");
					//console.log(accessedData);
					return <td key={accessor + i} className={overrideCenter?'ReportTableEntrySufficiency':isAce?'ReportTableEntryACE':'ReportTableEntry'} id={props.name + accessor}
						style={setting.style}>
						<div>
							<div className={setting.centerWideJustified? 'CenterWideJustified ' : (setting.centerRightJustified || setting.accessor !== 'date') && !overrideCenter? 'CenterRightJustified ' + innerClassNames.join(" ") :  innerClassNames.join(" ")}>{accessedData}</div>
						</div>
					</td>
				})}
			</tr>
		});

		//add accumulated value
		if (props.accumulator) {
			const beforeCells = [];
			const afterCells = [];

			for (let i = 0; i < accumulatorIndex - 1; i++) {
				beforeCells.push(<td key={"emptyAccumCell" + i} />)
			}

			for (let j = accumulatorIndex; j < rowSettings.length - 1; j++) {
				afterCells.push(<td key={"emptyAccumCell" + j} />)
			}

			const data = applySettings(accumulatorSettings, accumulatedValue, accumulatorIndex,
				accumulatorInnerClassNames, accumulatorDollarSignOverride);
			accumulatorInnerClassNames.push("CenterRightJustified");

			rows.push(
				<tr key={props.name + "Accumulator"} className={"table-accumulator-row " + props.name}>
					{beforeCells}
					<td className={"ReportTableEntry"}>
						<div id={props.name + 'accumulator'}>
							{props.accumulatorDisplay}
						</div>
					</td>
					<td className={"ReportTableEntry"}>
						<div className={accumulatorInnerClassNames.join(" ")}>
							{data}
						</div>
					</td>
					{afterCells}
				</tr>
			)


		}
	}


	return (
		<React.Fragment>
			<table className={"ReportTable"}>
				<thead>
					<tr className={anyHeader?"ReportTableHeaders":"ReportTableHeadersEmpty"}>{headers}</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
			{tooltips}
		</React.Fragment>
	);
};


export default reportTable;



// WEBPACK FOOTER //
// ./src/hoc/ReportTable/ReportTable.js